import React, { Component} from 'react';
import { translate } from 'react-i18next';
import {AsyncTypeahead, Menu, MenuItem} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import ModalSearchFingerprint from './ModalSearchFingerprint';
import swal from 'sweetalert';
import Inputmask from 'inputmask';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../../generics/modal_person_search';
import { donationTypeExtraction } from '../../../libs/services';

var Config = require('../../../config');

class OfferData extends Component{
	constructor(props, context) {
		super(props, context);
		//this.autoHandleChange = this.autoHandleChange.bind(this);
		this.closeSearchFingerprint = this.closeSearchFingerprint.bind(this);
		this.updateStateDonor = this.updateStateDonor.bind(this);
		this.person_search = this.person_search.bind(this);
		this.getConvokePlaces = this.getConvokePlaces.bind(this);

		this.state = { 
	    	extraction_types:[],
	    	donation_types:[],
	    	day_sessions:[],
	    	convoke_places:[],
	    	health_facilities:[],
	    	facility_sections:[],
	    	relationships:[],
	    	rhGroup:[],
	    	dataSource:[],
	    	searchText: '',
	    	hemored:true,
	    	national_centers:[],
	    	rh_group:"",
	    	isLoading: false,
	    	optionsDonor:[],
	    	don_usr_clc:"",//criterio funcional cambiar lugar de colecta
	    }
	}

	//Consulta de servicios necesarios para la pantalla
	async componentDidMount() {
		var timestamp_hour = document.getElementById("timestamp_hour");
		var im = new Inputmask("__:__");

		if(timestamp_hour !== null){
			im.mask(timestamp_hour);
		}
  		

		this.props.onRef(this);
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			if(!this.props.agenda){
				this.props.state.timestamp = aux[0]+' '+aux[1];
				this.props.state.timestamp_date = aux[0];
				this.props.state.timestamp_hour = aux[1];
			}
				
			this.props.state.stats.last_donation_date = aux[0];
		})

		let aux_resp = await donationTypeExtraction("no_cells");
        if(aux_resp !== undefined){
            this.setState({
                extraction_types: aux_resp
            });
        }

		fetch(Config.default.apiGateway.URL+'work_sessions/'+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      day_sessions: response
		    });
		})

		this.getConvokePlaces();

		fetch(Config.default.apiGateway.URL+'health_facilities',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      health_facilities: response
		    });
		})

		//parentesco
		fetch(Config.default.apiGateway.URL+'lookups?type=FAMILIAR_RELATIONSHIP&option=actives&order=true',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      relationships: response
		    });
		})

		//grupos sanguineos
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      rhGroup: response
		    });
		})

		//national centers
		fetch(Config.default.apiGateway.URL+'national_centers?option=offers&health_facility='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      national_centers: response
		    });
		})

		//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=don_usr_clc',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      don_usr_clc: response
		    });
		})
	}

	componentWillUnmount() {
	    this.props.onRef(null)
	}

	getConvokePlaces(hf_id = sessionStorage.getItem('health_facilities_id')){
		fetch(Config.default.apiGateway.URL+'convoke_places?option=operatives&health_facilities_id='+hf_id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      convoke_places: response
		    });
		})
	}

	donationTypeSelected = (id, name, event, index, value) => {
		this.props.selectFieldHandle("id","donation_type_id",event, index, event.target.value);

		for(var i=0; i < this.state.donation_types.length;i++){
			if(parseInt(this.state.donation_types[i].donation_type.id,10) === parseInt(event.target.value,10)){
				if(this.state.donation_types[i].donation_type.patient_required===1){//La donacion requiere paciente
					if(this.props.state.patient_person_id === "" || this.props.state.patient_person_id === null){
						this.props.specialFields(0, 1);

						this.props.state.show_patient_data= true;
					}
				}else{
					this.props.state.show_patient_data= false;
					this.props.clearPatientSearch();
				}
			}
		}
	
	}

	healthFacilitySelected = (id, name, event, index, value) => {
		this.props.selectFieldHandle("id","health_facility_id",event, index, value);
		for(var i=0; i < this.state.health_facilities.length;i++){
			if(this.state.health_facilities[i].id === value){
				this.setState({
			    	facility_sections: this.state.health_facilities[i].facility_sections
			    });
			}
		}
	}

	//buscar ealth facility
	searchHealthFacility(id){
		var flag = false;
		for (var i = 0; i < this.state.health_facilities.length; i++) {
			for (var j = 0; j < this.state.health_facilities[i].facility_sections.length; j++) {
				if (this.state.health_facilities[i].facility_sections[j].id === id) {
					this.setState({
				    	facility_sections: this.state.health_facilities[i].facility_sections
				    });
				    this.props.autocompleteHandle("health_facility_id",this.state.health_facilities[i].id);
				    flag = true;
					break
				};
			};
			if (flag === true) {
				break;
			};
		};
	}

	extractionTypeSelected = (id, name, event, index, value) => {
		this.props.selectFieldHandle("id","donation_type_extraction_id",event, index, event.target.value);
		
		this.setState({donation_types:[]});
		
		this.props.autocompleteHandle('donation_type_id',"");
		
		if(event.target.value !== null){
			fetch(Config.default.apiGateway.URL+'donation_rules?option=donation_extraction&donation_extraction_id='+event.target.value,{ 
				method: 'get',
				headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			})
			.then(response => response.json())
			.then(response => {
				this.setState({
				donation_types: response
				});
			})
		}
	}

	//busqueda
	searchSomething(value){
		const self = this;
	    this.setState({
	      searchText: value
	    }, function() {
	      self.performSearch();
	    });
	}

	performSearch() {
		if (this.state.searchText.length >= 3) {
			fetch(Config.default.apiGateway.URL+'person?search='+this.state.searchText,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				for (var i = 0; i < response.length; i++) {
					response[i].names =  response[i].lastname1 +' '+ 
										(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== "" ?
											response[i].lastname2+' ' : '') + 
										response[i].names +' '+ response[i].birthday;
					response[i].id = response[i].person_id;
				};
				this.setState({
			      dataSource: response
			    });
			})

		} else{
			this.setState({
		        dataSource: []
		    });
		};
	}

	autoHandleChange = (name,chosenRequest,event,index,value) => {
		this.props.setInfoPatient(chosenRequest)
	}

	handleUpdateInput = (searchText) => {
		
	    this.setState({
	      searchText: searchText,
	    });
  	};

	searchByFingerprint(e){
		e.preventDefault();
		this.modal_search_fingerprint.handleShow();
	}

	clear(e){
		e.preventDefault();
		this.refs._handleSearchDonor._instance.getInstance().clear();
		this.props.clearSearch();
	}

	closeSearchFingerprint(res){
		this.setState({optionsDonor:[]});
		console.log(res);
		this.props.setInfoDonor(res);
	}

	_handleSearchDonor = (query) => {
	    this.setState({isLoading: true});
		fetch(Config.default.apiGateway.URL+'donors?search='+query,{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			       'Content-Type': 'application/json',
				}),
				cache:"no-store"
			})
			.then(response => response.json())
			.then(response => {
				if(response !== null){
					for (var i = 0; i < response.length; i++) {
						
						/* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/

						if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
							response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
												+response[i].names +' '+ 
												(response[i].birthday !== null ? response[i].birthday : '');
						
						}else{
							response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
												(response[i].birthday !== null ? response[i].birthday : '');
						}


						if(response[i].document !== null){							
							response[i].names +=' '+response[i].document_type_value;
							response[i].names +=' '+response[i].document_number;
							
						}
						response[i].id = response[i].donor_id;
					};
					
					this.setState({
						isLoading: false,
				      	optionsDonor: response
				    });
				}
			})
	}

	updateStateDonor(values) {
	    let value = '';
	    if (values.length > 0) {
	      value = values[0];
	    }
	    this.props.autocompleteHandle('blockFields',false);
	    this.props.autocompleteHandle('checkEditData',false);
	    
	    this.props.getInfo(value.id);
	}

	person_search(){
		this.modal_person_search.handleShow(
			'Donador',
			'donors'
		);
	}

	render(){
		const { t } = this.props;

		return(
				<div className="col-xs-12" style={{padding:"0px"}}>
					<fieldset >
					<legend>Datos Donación</legend>
						{this.props.agenda ?
							<div>
								<div className="col-xs-12 col-sm-2" >
									<span className="span-min">Fecha</span>
									<input className="form-control hour-input" type="date" name="timestamp_date" id="timestamp_date"
										value={ this.props.state.timestamp_date } onChange={ this.props.handleChange } disabled required/>
								</div>
								<div className="col-xs-12 col-sm-1">
									<span className="span-min">Hora</span>
									<input id="timestamp_hour" name="timestamp_hour" type="text" data-inputmask-alias="datetime" 
										data-inputmask-inputformat="HH:MM"  data-inputmask-placeholder="-" 
										value={this.props.state.timestamp_hour || ""} 
										className="form-control" onChange={this.props.handleChange} disabled required/>
								</div>
							</div>
							

							
						: <div className="col-xs-12 col-sm-2" style={{paddingRight:"0px"}}>
							<span className="span-min">{t('content.offers.form.timestamp')}</span>
							<input className="form-control" disabled name="timestamp" value={ this.props.state.timestamp } onChange={ this.props.handleChange } />
						</div>}
							
				 		

				 		<div className="col-xs-12 col-sm-2">
				        	<span className="span-min">{t('content.offers.form.day_session')}</span>
							<select required className="form-control" disabled value={ this.props.state.day_sesion_donation } 
					        	onChange={ this.props.selectFieldHandle.bind(null,"id","day_sesion_donation") } 
				              	name="day_sesion_donation" id="day_sesion_donation">
				                {
				                this.state.day_sessions.map(function(t) {
				                	return <option  key={t.id}  value={t.id} >{t.type_value} </option>;
				                })
				            }
				            </select>
				        </div>

						<div className={this.props.agenda ? "col-xs-12 col-sm-3" : "col-xs-12 col-sm-4"}>
							<span className="span-min">{t('content.offers.form.convoke_place')}</span>

							<select className="form-control" disabled={this.state.don_usr_clc.value === "NO"}
				             	value={ this.props.state.convoke_places_id || "" } onKeyPress={(e) => this.props.validate(e)} required
					        	onChange={ this.props.selectFieldHandle.bind(null,"id","convoke_places_id") } autoFocus={true}
				              	name="convoke_places_id" id="convoke_places_id" >
				              		<option value="">Seleccionar...</option>
				                {
				                this.state.convoke_places.map(function(t) {
				                  return <option key={t.convoke_places.id}  value={t.convoke_places.id} >{t.convoke_places.name} </option>;
				                })
				            }
			              	</select>
				        </div>				        

				        <div className="col-xs-12 col-sm-2">
				        	<span className="span-min">{t('content.offers.form.extraction_type')}</span>
							<select className="form-control" onKeyPress={(e) => this.props.validate(e)}
								value={ this.props.state.donation_type_extraction_id || ""} required
					        	onChange={ this.extractionTypeSelected.bind(null,"id","donation_type_extraction_id") }
				              	name="donation_type_extraction_id"id="donation_type_extraction_id"
								disabled={!this.props.state.can_edit}>
				              	<option value="" disabled>Seleccionar...</option>
				                {
				                this.state.extraction_types.map(function(t) {
				                	return <option key={t.id} value={t.id} >{t.donation_type_process}</option>;
				                })
				            }
				            </select>
				        </div>

				        <div className="col-xs-12 col-sm-2">
				        	<span className="span-min">{t('content.offers.form.donation_type')}</span>
							<select className="form-control" name="donation_type_id" id="donation_type_id" required
					        	value={ this.props.state.donation_type_id || ""} onKeyPress={(e) => this.props.validate(e)}
					        	onChange={ this.donationTypeSelected.bind(null,"id","donation_type_id") }
								disabled={!this.props.state.can_edit}
								>
					        	<option value="" disabled >Seleccionar...</option>
				                {
				                this.state.donation_types.map(function(t) {
				                	return <option key={t.donation_type.id} value={t.donation_type.id} >{t.donation_type_lookup}</option>;
				                })
				            }
				            </select>
				        </div>
				        {this.props.state.option !== 'edit'?
					        <div style={{padding:"0px"}}>
						        <div className="col-xs-7">
						 			<span className="span-min">{t('content.generics.buttons.search')}</span>
							        <AsyncTypeahead
							          labelKey={(option) => `${option.names}`}
							          minLength={3}
							          maxLength={50}							          
							          inputProps={{
						          		name:"offer",
						          		id:"offer"
						          	  }}
						          	  id="offer_search"
							          onSearch={this._handleSearchDonor}
							          placeholder="Buscar por apellidos más nombre o número de documento..."
							          options={this.state.optionsDonor}
							          onChange={this.updateStateDonor}
							          ref="_handleSearchDonor"
							          useCache={false}
							          isLoading={this.state.isLoading}
							          delay={600}
							          paginationText="Mostrar mas resultados..."
							        />
							 			
								</div>
								<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
									<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
										onClick={this.person_search}/>
								</div>

						        <div className="col-xs-12 col-sm-4">
						        	<div className="col-xs-12 col-sm-8">
									{this.props.don_hue_dig.value==="YES"?
										<button style={{marginTop:"16px"}} type="button" className="btn btn-info button-min" onClick={(e) => this.searchByFingerprint(e)}>
											BUSCAR POR HUELLA
										</button>
									:null}
									<button style={{marginTop:"16px",marginLeft:"5px", marginLeft:'8px'}} type="button" className="btn btn-second button-min" onClick={(e)=>this.clear(e)}>
										LIMPIAR
									</button>
									</div>
									<ModalSearchFingerprint {...this.props} onRef={ref => (this.modal_search_fingerprint = ref)} save={this.closeSearchFingerprint}/>
						        </div>
						    </div>
					    :null}
				        
				        
			        </fieldset>
					{/*this.props.state.show_patient_data ? //Mostrar campos par registrar paciente 
					
				    :null*/}

				    <ModalPersonSearch {...this.props} waiting={this.props.waiting} updatePerson={this.updateStateDonor} onRef={ref => (this.modal_person_search = ref)} />
				</div>
		)
	}
}

export default translate('translations')(OfferData);